import "webpack-jquery-ui/sortable"

import "stylesheets/photo_order.scss"
import "webpack-jquery-ui/css"

document.addEventListener('DOMContentLoaded', () => {
  if($('.spine_text_color')) {
    $('.spine_text_color').change(function() {
      var red = parseInt($('#output_order_spine_text_color_red').val(), 10)
      var blue = parseInt($('#output_order_spine_text_color_blue').val(), 10)
      var green = parseInt($('#output_order_spine_text_color_green').val(), 10)
      $('#spine_text_color').css('background-color', 'rgb(' + red + ',' + green + ',' + blue + ')')
    })
  }

  if($('.spine_color')) {
    $('.spine_color').change(function() {
      var red = parseInt($('#output_order_spine_color_red').val(), 10)
      var blue = parseInt($('#output_order_spine_color_blue').val(), 10)
      var green = parseInt($('#output_order_spine_color_green').val(), 10)
      $('#spine_color').css('background-color', 'rgb(' + red + ',' + green + ',' + blue + ')')
    })
  }

  if($('#sortable_list')) {
    const url = $('#sortable_list').data('url')
    $('#sortable_list').sortable({
      update: function () {
        $.ajax({
          type: 'POST',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
          },
          data: $('#sortable_list').sortable('serialize'),
          dataType: 'script',
          url: url
        })
      }
    })
  }

  if($('#same_as_billing')) {
    $('#same_as_billing').click(function() {
      if ($('#same_as_billing').is(":checked")) {
        $('#order_ship_cust_first_name').val($('#order_bill_cust_first_name').val());
        $('#order_ship_cust_last_name').val($('#order_bill_cust_last_name').val());
        $('#order_ship_cust_addr1').val($('#order_bill_cust_addr1').val());
        $('#order_ship_cust_addr2').val($('#order_bill_cust_addr2').val());
        $('#order_ship_cust_city').val($('#order_bill_cust_city').val());
        $('#order_ship_cust_state').val($('#order_bill_cust_state').val());
        $('#order_ship_cust_zip').val($('#order_bill_cust_zip').val());
        $('#order_ship_cust_country').val($('#order_bill_cust_country').val());
        $('#order_ship_cust_phone').val($('#order_bill_cust_phone').val());
      } else {
        $('#order_ship_cust_first_name').val('');
        $('#order_ship_cust_last_name').val('');
        $('#order_ship_cust_addr1').val('');
        $('#order_ship_cust_addr2').val('');
        $('#order_ship_cust_city').val('');
        $('#order_ship_cust_state').val('');
        $('#order_ship_cust_zip').val('');
        $('#order_ship_cust_country').val('');
        $('#order_ship_cust_phone').val('');
      }
    })
  }
})
